/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : BrandLogo.jsx
 * description   : {{insert here}}
 * creation date : 16/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Flex,
    Image,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
    toolKit,
} from '@/components/core';

import {
    route_list,
} from '@/utils/router/core';

import {
    RouterLink,
} from '@/components/snippets/RouterLink';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const brand_logo_variant =
{
    square: 'square',
    squareBackground: 'square-background',
    squareRounded: 'square-rounded',
    squareRoundedBackground: 'square-rounded-background',
    horizontal: 'horizontal',
    vertical: 'vertical',
};

const brand_logo_color =
{
    default: 'default',
    light: 'light',
    dark: 'dark',
};



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function BrandLogo({ height, logoVariant = brand_logo_variant.horizontal, logoColor = brand_logo_color.default, ...rest }) {
    // Component context
    const { ctx } = useComponentContext();

    // Logo component
    const images = require.context('@/assets/images', true);
    const logo = images('./logo/' + logoVariant + '/' + logoColor + '/medium.png');

    return (
        <Fragment>
            <Flex
                direction='row'
                justifyContent='center'
                gap={ctx.theme.tokens.space.zero}
            >
                <Flex
                    direction='row'
                    alignItems='center'
                    alignContent='center'
                    wrap='nowrap'
                    gap={ctx.theme.tokens.space.zero}
                    {...rest}
                >
                    <RouterLink
                        to={
                            toolKit.api.location.buildUrl(
                                route_list.HOME
                            )
                        }
                        className='brand-logo-link'
                    >
                        <Image
                            src={logo}
                            height={height}
                            display='block'
                        />
                    </RouterLink>
                </Flex>
            </Flex>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    BrandLogo,
    brand_logo_variant,
    brand_logo_color,
};



// End of file
